var $4177820c66af565d$exports = {};
document.addEventListener('DOMContentLoaded', ()=>{
    const input = document.getElementById('pills-search-input');
    const sections = Array.from(document.querySelectorAll('[data-pill-category-section]'));
    const cards = Array.from(document.querySelectorAll('[data-pill-card]'));
    const emptyState = document.getElementById('pills-empty-state');
    if (!input || !sections.length || !cards.length || !emptyState) return;
    const normalize = (value)=>value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^\p{L}\p{N}\s-]/gu, ' ').replace(/\s+/g, ' ').trim();
    const applyFilter = ()=>{
        const query = normalize(input.value);
        const terms = query ? query.split(' ') : [];
        let visibleCards = 0;
        for (const card of cards){
            const haystack = normalize(card.dataset.search || '');
            const matches = !terms.length || terms.every((term)=>haystack.includes(term));
            card.hidden = !matches;
            if (matches) visibleCards += 1;
        }
        for (const section of sections){
            const hasVisibleCards = Array.from(section.querySelectorAll('[data-pill-card]')).some((card)=>!card.hidden);
            section.hidden = !hasVisibleCards;
        }
        emptyState.hidden = visibleCards > 0;
    };
    input.addEventListener('input', applyFilter);
    input.addEventListener('search', applyFilter);
    applyFilter();
});


//# sourceMappingURL=pills.bb7cdc98.js.map
